import template from "./currency-selector.html";
import currenciesTranslations from "../../../../common/translations/currencies";

const CurrencySelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class CurrencySelectorController {
    /* @ngInject */
    constructor($scope, $rootScope, currencies, Utils, $window) {
      const language = $rootScope.organization
        ? $rootScope.organization.settings.appLanguage
        : $window.navigator.language.split("-")[0] === "es"
        ? "es"
        : "en";
      this.$scope = $scope;
      this.currencies = currencies;
      this.currencyFilter = Utils.filterDiacriticsInsensitive(currenciesTranslations, language, true);
    }

    $onInit() {
      this.currency = this.defaultValue;
      this.$scope.$watch(
        () => this.currency,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) this.onChange({ oldCurrency: oldVal, newCurrency: this.currency });
        },
      );
    }

    $onChanges(changesObj) {
      if (changesObj.defaultValue && !changesObj.defaultValue.isFirstChange()) this.currency = this.defaultValue;
    }
  },
};

export default CurrencySelectorComponent;
